import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  Contact,
  ContactStoredData, 
  SimpleReponseResult,
  SearchContactsParameters,
  TraceConnectParameters,
  PS_Lst_Contacts_Result
} from '../all-models';
import { SharedDataService } from './shared-data/shared-data.service';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

 ContactsUrl: string 
  constructor(private http: HttpClient, public sharedDataSvc: SharedDataService) { 
    this.ContactsUrl = this.sharedDataSvc.apiBaseUrl + 'Contacts';
  }


  getContact(userId: number): Observable<Contact> {
    return this.http.get<Contact>(`${this.ContactsUrl}/${userId}`);
  }

  postContact(contact: Contact) : Observable<Contact> {
    contact.CreationDate= new Date();
    return this.http.post<Contact>(this.ContactsUrl,contact);
  }

  
  putContact(id: number,contact: Contact) : Observable<Contact> {
    let paramContact:Contact=new Contact();
    Object.assign(paramContact,contact);
    if (contact.Civility){
      paramContact.CivId = contact.Civility.Id;
      paramContact.Civility = null; 
      paramContact.SupplierContacts = null;
      paramContact.ExtUsers = null;
    }    
    if (!paramContact.CreationDate) paramContact.CreationDate= new Date();
    return this.http.put<Contact>(`${this.ContactsUrl}/${id}`,paramContact);
  }

  
  delContact(contact: Contact) : void {
    this.http.delete<Contact>(`${this.ContactsUrl}/${contact.Id}`);
  }

  ContactByMail(email:string):Observable<Contact>{
    let contact : Contact = new Contact();
    contact.Email = email;
    return this.http.post<Contact>(`${this.ContactsUrl}/ContactByMail`, contact);
  }


  searchContacts(searchContactsParameters:SearchContactsParameters):Observable<Contact[]>{
    return this.http.post<Contact[]>(`${this.ContactsUrl}/searchContacts`, searchContactsParameters)
    .pipe(map(contacts=> {
      //Si emailDiff non renseigné, on lui met l'email du Gid
      contacts.forEach(contact=> contact.EmailDiff = contact.EmailDiff || contact.Email);
      return contacts;
    }));
  }

  traceConnection(traceConnectParameters:TraceConnectParameters):Observable<void>{
    return this.http.post<void>(`${this.ContactsUrl}/traceConnection`, traceConnectParameters);
  }

  LstContacts():Observable<PS_Lst_Contacts_Result[]>{
    return this.http.get<PS_Lst_Contacts_Result[]>(`${this.ContactsUrl}/Liste/${this.sharedDataSvc.lngCod}`);
  }
}
